import React, { useEffect, useState } from "react";

export default function Loading() {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        // شبیه‌سازی پیشرفت نرم تا 90٪ (منتظر بارگذاری واقعی)
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 90) return prev;
                const step = prev < 40 ? 4 : prev < 70 ? 2 : 0.6;
                return Math.min(prev + step, 90);
            });
        }, 90);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center
                        bg-gradient-to-br from-white via-teal-50/40 to-amber-50/40
                        dark:from-slate-950 dark:via-slate-900 dark:to-teal-950/60
                        overflow-hidden">

            {/* ==== ambient blobs ==== */}
            <div className="pointer-events-none absolute inset-0 overflow-hidden">
                <div className="absolute -top-32 -left-32 w-[26rem] h-[26rem] rounded-full
                                bg-teal-400/20 dark:bg-teal-500/10 blur-3xl animate-pulse" />
                <div className="absolute -bottom-32 -right-32 w-[26rem] h-[26rem] rounded-full
                                bg-amber-300/25 dark:bg-amber-400/10 blur-3xl animate-pulse [animation-delay:1.5s]" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                                w-[30rem] h-[30rem] rounded-full
                                bg-teal-300/10 dark:bg-teal-700/10 blur-3xl animate-pulse [animation-delay:3s]" />
            </div>

            {/* ==== main ==== */}
            <div className="relative z-10 w-full max-w-md mx-4 flex flex-col items-center">

                {/* brand name */}
                <div className="text-center mb-2">
                    <h1 className="text-6xl sm:text-5xl font-black tracking-tight
                                  bg-gradient-to-r from-amber-500 via-teal-600 to-teal-800
                                  dark:from-amber-300 dark:via-teal-400 dark:to-teal-200
                                  bg-clip-text text-transparent">
                        رایابات
                    </h1>
                    <p className="text-[14px] sm:text-xs text-slate-400 dark:text-slate-500 mt-2 tracking-[0.45em] font-semibold">
                        R A Y A B O T
                    </p>
                </div>

                {/* ==== progress bar ==== */}
                <div className="w-full">
                    {/* percentage + status */}
                    <div className="flex items-center justify-between mb-3 text-xs">
                        <span className="text-slate-500 dark:text-slate-400 font-medium">
                            در حال آماده‌سازی...
                        </span>
                        <span className="font-bold tabular-nums
                                         bg-gradient-to-r from-amber-500 to-teal-600
                                         dark:from-amber-300 dark:to-teal-400
                                         bg-clip-text text-transparent">
                            {Math.round(progress)}٪
                        </span>
                    </div>

                    {/* track */}
                    <div className="relative h-2 w-full rounded-full overflow-hidden
                                    bg-slate-200/70 dark:bg-slate-800/70
                                    ring-1 ring-inset ring-slate-300/40 dark:ring-white/5">

                        {/* fill: gradient from gold to teal (RTL: gold on right, teal on left) */}
                        <div
                            className="absolute inset-y-0 right-0 rounded-full
                                       bg-gradient-to-l from-amber-400 via-amber-500 to-teal-600
                                       shadow-[0_0_16px_rgba(13,148,136,0.55)]
                                       transition-all duration-300 ease-out"
                            style={{ width: `${progress}%` }}
                        >
                            {/* moving sheen */}
                            <span className="absolute inset-0
                                             bg-gradient-to-r from-transparent via-white/50 to-transparent
                                             bg-[length:200%_100%]
                                             animate-[sheen_1.6s_linear_infinite]" />
                            {/* glowing gold edge (head of bar) */}
                            <span className="absolute inset-y-0 left-0 w-[3px]
                                             bg-gradient-to-b from-amber-200 to-amber-400
                                             shadow-[0_0_10px_rgba(251,191,36,0.9)]" />
                        </div>
                    </div>

                    {/* dots under bar */}
                    <div className="flex items-center justify-center gap-1.5 mt-4">
                        {[0, 1, 2].map((i) => (
                            <span
                                key={i}
                                className="w-1.5 h-1.5 rounded-full
                                           bg-gradient-to-br from-amber-400 to-teal-500
                                           animate-bounce"
                                style={{ animationDelay: `${i * 0.15}s` }}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* keyframes */}
            <style>{`
                @keyframes sheen {
                    0%   { background-position: 200% 50%; }
                    100% { background-position: -200% 50%; }
                }
            `}</style>
        </div>
    );
}